import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { Package, ClipboardList, Banknote, AlertTriangle } from "lucide-react";

export default function DashboardTab() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <p className="text-muted-foreground">Loading…</p>;

  const cards = [
    { label: "Total Orders", value: d.total_orders, icon: ClipboardList, color: "text-steel" },
    { label: "Awaiting Payment", value: d.awaiting_payment, icon: Banknote, color: "text-accent" },
    { label: "Products", value: d.products, icon: Package, color: "text-emerald-600" },
    { label: "Price Reviews", value: d.pending_reviews, icon: AlertTriangle, color: "text-destructive" },
  ];

  return (
    <div>
      <h1 className="text-3xl font-extrabold mb-1">Dashboard</h1>
      <p className="text-muted-foreground mb-6">ACP Online commercial overview</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 mb-8">
        {cards.map((c) => (
          <div key={c.label} data-testid={`stat-${c.label.replace(/\s/g, "-").toLowerCase()}`}
            className="rounded-xl border bg-white p-5">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">{c.label}</span>
              <c.icon size={18} className={c.color} />
            </div>
            <div className="mt-2 text-3xl font-extrabold font-mono">{c.value}</div>
          </div>
        ))}
      </div>
      <div className="rounded-xl border bg-white p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading font-bold text-lg">Recent Orders</h2>
          <span className="text-sm text-muted-foreground">Revenue (excl. cancelled): <strong className="font-mono">{money(d.revenue)}</strong></span>
        </div>
        <div className="divide-y">
          {d.recent_orders.length === 0 && <p className="text-sm text-muted-foreground py-4">No orders yet.</p>}
          {d.recent_orders.map((o) => (
            <div key={o.order_number} className="flex items-center justify-between py-3 text-sm">
              <span className="font-mono font-semibold">{o.order_number}</span>
              <span>{o.customer?.name}</span>
              <span className="text-muted-foreground">{o.status_label}</span>
              <span className="font-mono">{money(o.total)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
